 <button
    *ngIf="!critical"
    class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
    [ngStyle]="buttonStyles"
    [ngClass]="buttonClass"
    type="button"
   [style.width]="width"
      [style.font-size]="fontSize"
      [style.height]="height"
      [style.padding]="padding"
    title="Import Data"
      [attr.title]="title"
      [appCriticalOperation]="buttonId"
     [disabled]="disabled"
    (click)="handleClick($event)"
    style="    margin-left: 0;
    margin-right: 0;"
    >
    {{ label }}
      <em *ngIf="icon" class="{{ icon }}" style="font-size: 12px; padding: 0 5px;"></em>
</button>
 <button
     *ngIf="critical"
    class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
    [ngClass]="buttonClass"
    [ngStyle]="buttonStyles"
    type="button"
   [style.width]="width"
    [style.font-size]="fontSize"
    [style.height]="height"
    [style.padding]="padding"
    title="Import Data"
    [attr.title]="title"
    [appCriticalOperation]="buttonId"
    [disabled]="disabled"
    [criticalMethod]="onCriticalMethod"
     style="    margin-left: 0;
    margin-right: 0;"
    >
   {{ label }}
      <em *ngIf="icon" class="{{ icon }}" style="font-size: 12px; padding: 0 5px;"></em>
</button>
